import { useCallback } from "react"
import { useSetRecoilState } from "recoil"
import { runtimeEnvForceReloadFlag } from "state/ecoState"

/**
 * Hooks that return a function to reload the "runtimeEnv"
 */
export const useReloadRuntimeEnv = (): UseReloadRuntimeEnv => {
    const setReloadFlag = useSetRecoilState(runtimeEnvForceReloadFlag)
    const reload = useCallback(() => {
        setReloadFlag(Date.now())
    }, [])

    return reload
}
/** Triggering this function will reload the "runtimeEnv" state */
type UseReloadRuntimeEnv = () => void
